import { motion } from 'framer-motion'
import EditIcon from '../../../../assets/svgs/EditIcon'
import style from './MainProfile.module.css'

const QuoteIcon = () => (
  <svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 22V13.75C0 9.91667 0.916667 6.75 2.75 4.25C4.58333 1.75 7.25 0.166667 10.75 -0.5L11.75 1.75C9.58333 2.25 7.83333 3.33333 6.5 5C5.16667 6.66667 4.5 8.75 4.5 11.25H8V22H0ZM16 22V13.75C16 9.91667 16.9167 6.75 18.75 4.25C20.5833 1.75 23.25 0.166667 26.75 -0.5L27.75 1.75C25.5833 2.25 23.8333 3.33333 22.5 5C21.1667 6.66667 20.5 8.75 20.5 11.25H24V22H16Z"
      fill="rgba(97,72,124,0.12)"
    />
  </svg>
)

const fadeUp = {
  hidden: { opacity: 0, y: 14 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.42, ease: [0.22, 1, 0.36, 1] } },
}

const About = ({ title, userProfile, openModal, toggleModal, owner, removeComponent, editMode }) => {
  if (!userProfile?.about?.length) return null

  const content = userProfile?.about?.[0]?.content

  return (
    <motion.div
      className={style.aboutWrapper}
      variants={fadeUp}
      initial="hidden"
      animate="visible"
    >
      <div className={style.header}>
        <p className={style.title}>About {title}</p>
        {owner && editMode && (
          <div
            style={{ cursor: 'pointer' }}
            onClick={() =>
              !content
                ? toggleModal('about', userProfile?.about?.[0], 'create')
                : toggleModal('about', userProfile?.about?.[0])
            }
            title="Edit about"
          >
            <EditIcon />
          </div>
        )}
      </div>

      <div style={{ position: 'relative', paddingLeft: 4 }}>
        <div style={{ position: 'absolute', top: -4, left: -6, pointerEvents: 'none' }}>
          <QuoteIcon />
        </div>
        <p className={style.text} style={{ paddingLeft: 6 }}>
          {content || 'No content available'}
        </p>
      </div>
    </motion.div>
  )
}

export default About
